<!-- Display transaction history of customer -->
<!-- error message in case of unauthorised user -->
<ng-container *ngIf="role && role === 'CUSTOMER'">
    <h1>UNAUTHORISED ACCESS</h1> <br>
    <h3>Please Login as MODERATOR or TECH EXPERT, redirecting ...</h3>
    {{unauthorised()}}
  </ng-container>
  <ng-container *ngIf="role && role !== 'CUSTOMER'" >
    <div class="wrapper ">
      <br>
      <div>
        <div class="content">
          <ng-container *ngIf="allFilteredCustomers">
            <div>
              <div class="alert alert-danger" role="alert" *ngIf="totalTransactions.length === 0">
                No transactions
              </div>
            </div>
  
            <div class="card">
            <div class="card-body">
              <div style="text-align: center;">
                <form [formGroup]="dateForm">
                  <mat-form-field appearance="fill">
                    <mat-label>Pick a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker" >
                      <input formControlName="startDate" matStartDate placeholder="Start date" required>
                      <input formControlName="endDate" matEndDate placeholder="End date" required>
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                  </mat-form-field>
                </form>
                <button type="button" class="btn btn-success" (click)="filter()">FILTER</button>
                <button type="button" class="btn btn-warn" (click)="reset()">RESET</button>
                <mat-error *ngIf="missingFields">Date Range is required</mat-error>
                <br><br>
              <!-- <button *ngIf="alltransactions.length>0" type="button" class="btn btn-info" (click)="downloadPdf()">Download</button> -->
              </div>
              <table class="table table-hover">
                <thead class=" text-primary">
                  <tr>
                    <th>Customer ID</th>
                    <th>Customer Name</th> 
                    
                      <th>Type</th>
                      <th>Amount</th> 
                      <th>Added Date</th>
                      <th>Balance Available</th>
                      <th>Purpose</th>
                      <th>Date Of Payment</th>
                      <th>Payment mode</th>
                      <th>Reference No</th>
                    
                  </tr>
                </thead>
                <tbody>
                  
                 

                    <ng-container *ngFor="let customer of allFilteredCustomers">
                      <tr *ngFor="let transaction of customer.transactions">

                        <td>
                          <div *ngIf="!customer.customerId">
                            Customer Details unavailable
                          </div>
                          <div *ngIf="customer.customerId">
                            {{customer.customerId._id}}
                          </div>
                          
                        </td>
                        <td>
                          <div *ngIf="!customer.customerId">
                            Customer Details unavailable
                          </div>
                          <div *ngIf="customer.customerId">
                            {{customer.customerId.fullName}}
                          </div>
                          
                        </td> 

                        <td>{{transaction.type}}</td>
                        <td>{{transaction.amount}}</td>
                       
                        <td>{{transformDate(transaction.createdAt)}}</td>
                        <td>{{transaction.balance}}</td>
                        
                        <td>
                          <div *ngIf="transaction.type=='CREDIT'">
                              <div *ngIf="!transaction.purpose"> Details Unavailable</div>
                              <div *ngIf="transaction.purpose">{{transaction.purpose}}</div>
                          </div>
                          <div *ngIf="transaction.type=='DEBIT'">
                            <div *ngIf="!transaction.Purpose"> Details Unavailable</div>
                            <div *ngIf="transaction.Purpose">{{transaction.Purpose}}</div>
                        </div>
                        </td>
    
                        <td>
                          <div *ngIf="transaction.type=='CREDIT'">
                            <div *ngIf="!transaction.date_of_payment"> Details Unavailable</div>
                            <div *ngIf="transaction.date_of_payment">{{transaction.date_of_payment}}</div>
                          </div>
                          <div *ngIf="transaction.type=='DEBIT'">
                            <div>Not applicable</div>
                          </div>
                        </td>
    
                        <td>
                          <div *ngIf="transaction.type=='CREDIT'">
                            <div *ngIf="!transaction.payment_mode"> Details Unavailable</div>
                            <div *ngIf="transaction.payment_mode">{{transaction.payment_mode}}</div>
                          </div>
                          <div *ngIf="transaction.type=='DEBIT'">
                            <div>Not applicable</div>
                          </div>
                        </td>
    
                        <td>
                          <div *ngIf="transaction.type=='CREDIT'">
                              <div *ngIf="!transaction.payment_reference"> Details Unavailable</div>
                              <div *ngIf="transaction.payment_reference">{{transaction.payment_reference}}</div>
                          </div>
                          <div *ngIf="transaction.type=='DEBIT'">
                            <div *ngIf="!transaction.Reference_Number"> Details Unavailable</div>
                            <div *ngIf="transaction.Reference_Number">{{transaction.Reference_Number}}</div>
                          </div>
                        </td>

                      </tr>
                    </ng-container>
                   

                    <!-- </tr> -->
                </tbody>
              </table>
            </div>
          </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>
  
  <!-- end of transaction display-->
  